import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-enterprise";
import moment from "moment";

export const useTableData = () => {
	const columns: ColDef[] = [
		{
			field: "Start",
			headerName: "Date",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.Start}`, "MM/dd") || "",
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			sortable: true,
		},
		{
			field: "AssetName",
			headerName: "Asset",
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			sortable: true,
		},
		{
			field: "Shift",
			headerName: "Shift",
			valueGetter: (params) => params.data?.Shift || "",
			minWidth: 80,
			maxWidth: 80,
			flex: 1,
			sortable: true,
		},
		{
			field: "Crew",
			headerName: "Crew",
			valueGetter: (params) => params.data?.Crew || "",
			minWidth: 80,
			maxWidth: 80,
			flex: 1,
		},
		{
			field: "SectionName",
			headerName: "Section",
			valueGetter: (params) => params.data?.SectionName || "",
			minWidth: 80,
			maxWidth: 80,
			flex: 1,
		},
		{
			field: "Start",
			headerName: "Start",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.Start}`, "HH:mm:ss") || "",
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			sortable: true,
		},
		{
			field: "End",
			headerName: "End",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.End}`, "HH:mm:ss") || "",
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			sortable: true,
		},
		{
			field: "Duration",
			headerName: "Duration",
			valueFormatter: (params) => {
				if (params.value) {
					const duration = moment.duration(params.value, "seconds");
					const minutes = Math.floor(duration.asMinutes());
					const seconds = duration.seconds();

					const formattedMinutes = String(minutes).padStart(2, "0");
					const formattedSeconds = String(seconds).padStart(2, "0");

					return `${formattedMinutes}m ${formattedSeconds}s`;
				}
				return "";
			},
			minWidth: 80,
			maxWidth: 120,
			flex: 1,
			sortable: true,
		},
		{
			field: "DelayCodePath",
			headerName: "Code",
			valueGetter: (params) => {
				const delayCodeName = params.data?.DelayCodeName;
				const delayCodePath = params.data?.DelayCodePath;

				const isSystemDelayCode =
					delayCodeName === "Adjustment" ||
					delayCodeName === "Undeclared Mill" ||
					delayCodeName === "Undeclared Cold Shear";

				let displayPath = delayCodePath;
				const maxLength = 40;

				// If the path is longer than maxLength, intelligently truncate it
				if (delayCodePath && delayCodePath.length > maxLength) {
					let remainingPath = delayCodePath;

					// As long as the path is too long and has bars
					while (
						remainingPath.length > maxLength &&
						remainingPath.includes("/")
					) {
						// Delete the first segment of the path (up to the first bar)
						const firstSlashPos = remainingPath.indexOf("/");
						remainingPath = remainingPath.substring(firstSlashPos + 1);
					}

					// If we manage to reduce the path, add the prefix ".../"
					if (remainingPath !== delayCodePath) {
						displayPath = ".../" + remainingPath;
					}
				}

				return isSystemDelayCode ? delayCodeName : displayPath;
			},
			flex: 2,
			cellStyle: {
				justifyContent: "flex-start",
			},
			wrapText: true,
			autoHeight: true,
		},
		{
			field: "DelayCategoryName",
			headerName: "Category",
			maxWidth: 150,
			editable: false,
			flex: 1,
			sortable: true,
		},
		{
			field: "Comments",
			headerName: "Comments",
			minWidth: 120,
			flex: 3,
			sortable: true,
			cellStyle: {
				justifyContent: "flex-start",
			},
			wrapText: true,
			autoHeight: true,
		},
		{
			field: "JustifiedByUser",
			headerName: "User",
			maxWidth: 100,
			minWidth: 100,
			editable: false,
			flex: 1,
			sortable: true,
		},
		{
			field: "JustifiedDateTime",
			headerName: "Justification",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.Start}`, "HH:mm:ss") || "",
			maxWidth: 150,
			minWidth: 100,
			flex: 1,
			sortable: true,
		},
	];

	return { columns };
};
